export const CORE = 'CORE';
export const COREFLATTEN = 'COREFLATTEN';
export const USER = 'USER';
export const USERFLATTEN = 'USERFLATTEN';
